<p>Release Info:</p>
<p>api @{{ ApiVersion }} - ui @{{ UiVersion }}</p>